const question2 = {
    'question': 'Na czym polega psychoterapia?',
    'answer': 'Psychoterapia opiera się na bezpośrednim kontakcie terapeuty z pacjentem. Obejmuje ona cykl spotkań pacjenta z terapeutą, indywidualnych lub w większej grupie, w zależności od rodzaju terapii. Psychoterapia pomaga w leczeniu zaburzeń takich jak: depresje, stany lękowe, fobie, zaburzenia żywienia oraz wspiera wyjście z trudnych sytuacji życiowych.'
}

export default question2;